import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

export const sessionGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  if (sessionService.isSessionValid()) {
    return true;
  }

  if (sessionService.hasSession()) {
    return router.createUrlTree(['/expired']);
  }

  return router.createUrlTree(['/error']);
};
